import { useState, useEffect } from 'react';
import { getAuthToken, isAuthenticated } from '../../../auth/tokenvalidation';
import {
  QUICK_FILTERS,
  buildListUrl,
  fetchJson,
} from '../utils/procurementList';

// Draft counts per quick filter (ready / due soon / overdue) for one category.
// Uses the list endpoint with PageSize=1 and reads totalItems.
const useProcurementInsights = ({ procurementTypeHeader, refreshTrigger }) => {
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    const token = getAuthToken();
    if (!procurementTypeHeader || !token || !isAuthenticated()) {
      return undefined;
    }

    const controller = new AbortController();
    setInsights(null);

    Promise.all(
      QUICK_FILTERS.map(async filter => {
        const result = await fetchJson(
          buildListUrl({
            currentPage: 1,
            rowsPerPage: 1,
            procurementTypeHeader,
            quickFilter: filter.key,
          }),
          token,
          controller.signal
        );
        return [filter.key, result?.data?.totalItems || 0];
      })
    )
      .then(entries => setInsights(Object.fromEntries(entries)))
      .catch(error => {
        // The banner is a hint only; the table reports real load failures.
        if (error.name !== 'AbortError') setInsights(null);
      });

    return () => controller.abort();
  }, [procurementTypeHeader, refreshTrigger]);

  return insights;
};

export default useProcurementInsights;
